import MuiTableRow from "@mui/material/TableRow";

export default function TableRow(props) {
  return <MuiTableRow {...props} />;
}
